import { CoreButton, CoreCheckbox, CoreInput, CoreSelect } from '@components'
import HintIcon from '@images/icons/hint_select_role_icon.svg?react'
import { useCurrencies, useEditCryptoAddressQry } from 'mmfintech-backend-api'
import type { Currency, ExternalCryptoAddressResponse } from 'mmfintech-backend-api/types'
import { tr } from 'mmfintech-commons'
import { ErrorDisplay } from 'mmfintech-portal-commons'
import { useEffect } from 'react'
import ReactTooltip from 'react-tooltip'

const CreateCryptoRecipient = ({ currencyCode, foreignId, personal, onClose, onSuccess }) => {
  const { formValues, isTagRequired, error, fetching, handleSubmit } = useEditCryptoAddressQry({
    settlement: false,
    // recipientId,
    currencyCode,
    onClose,
    onSuccess: (response: ExternalCryptoAddressResponse) => onSuccess(response?.paymentInstrumentId)
  })

  const { currencyOptions } = useCurrencies()

  const handleClick = () => formValues.setValue('personal', !formValues.getValue('personal'))

  useEffect(() => {
    formValues.setValue('foreignId', foreignId)
    formValues.setValue('personal', foreignId ? false : personal)
  }, [])

  return (
    <>
      <CoreInput
        type='text'
        data-test='account-name'
        label={tr('FRONTEND.RECIPIENTS.LABELS.ACCOUNT_NAME', 'Recipient name')}
        maxLength={100}
        {...formValues.registerInput('name')}
        autoComplete='off'
      />

      <CoreSelect
        type='currency'
        data-test='currency'
        label={tr('FRONTEND.ACCOUNTS.CREATE.CURRENCY_LABEL', 'Currency')}
        options={currencyOptions((c: Currency) => c.currencyCode === currencyCode)}
        value={formValues.getValue('currency')}
        disabled={true}
        // onChange={(_, val: any) => {
        //   formValues.setValue('currency', val.value)
        // }}
      />

      <CoreInput
        type='text'
        data-test='address'
        label={tr('FRONTEND.RECIPIENTS.LABELS.CRYPTO_ADDRESS', 'Address')}
        {...formValues.registerInput('address')}
        autoComplete='off'
      />

      {isTagRequired(formValues.getValue('currency')) && (
        <CoreInput
          type='text'
          data-test='tag'
          label={tr('FRONTEND.RECIPIENTS.CRYPTO.TAG', 'Tag')}
          {...formValues.registerInput('tag')}
          autoComplete='off'
        />
      )}

      <CoreInput
        type='text'
        data-test='description'
        label={tr('FRONTEND.RECIPIENTS.LABELS.DESCRIPTION', 'Description')}
        maxLength={100}
        {...formValues.registerInput('description')}
        autoComplete='off'
      />

      <CoreCheckbox
        className='form-checkbox'
        type='check'
        checked={Boolean(formValues.getValue('personal'))}
        value='personal'
        onClick={handleClick}
        label={tr('FRONTEND.RECIPIENTS.LABELS.CRYPTO_PERSONAL_ACCOUNT', 'This is my personal account')}
        {...formValues.registerCheckbox('personal')}
        disabled={foreignId || personal}
        hint={
          <span
            style={{ marginLeft: '8px' }}
            data-for='personal-account-tooltip'
            data-tip={tr(
              'FRONTEND.RECIPIENTS.LABELS.BANK_PERSONAL_ACCOUNT_TOOLTIP',
              'Personal accounts are your own external accounts and are only visible to you,<br/>administrators, and authorized departments within a company account.'
            )}
          >
            <HintIcon width={16} height={16} />
          </span>
        }
      />
      <ReactTooltip id='personal-account-tooltip' padding='8px 6px' html={true} aria-haspopup='true' />

      <ErrorDisplay error={error} />

      <CoreButton
        type='button'
        data-test='save-button'
        variation='elevated'
        size='large'
        text={tr('FRONTEND.RECIPIENTS.EDIT.BUTTON_SAVE_RECIPIENT', 'Save recipient')}
        className='save-button'
        onClick={handleSubmit}
        isLoading={fetching}
        disabled={fetching}
        fullWidth
      />
    </>
  )
}

export default CreateCryptoRecipient
